import { Space, Title, Descriptions } from '@bancobarigui/barihaus';
import type { CardHomogeneizacaoProps } from './types';
import { useCardHomogeneizacao } from './hooks';
import { formatarMoeda, formatarNumero } from '../shared/formatters';
import { CoeficienteVariacaoDisplay } from '../components/CoeficienteVariacaoDisplay';
import { LimiteDisplay } from '../components/LimiteDisplay';
import * as styles from './styles';

export * from './utils';

export function CardHomogeneizacao({ dadosValorTerreno, onAlertas }: CardHomogeneizacaoProps) {
  const { estatisticas } = useCardHomogeneizacao(dadosValorTerreno, onAlertas);

  return (
    <Space direction="vertical" size="middle" style={styles.containerStyle}>
      <Title level={4} style={styles.titleStyle}>
        Homogeneização
      </Title>

      <Descriptions
        bordered
        size="small"
        column={1}
        items={[
          {
            key: '1',
            label: 'Número de elementos',
            children: estatisticas.numeroElementos,
          },
          {
            key: '2',
            label: 'Unitário Homog.',
            children: formatarMoeda(estatisticas.unitarioHomog),
          },
          {
            key: '3',
            label: 'Desvio Padrão',
            children: formatarNumero(estatisticas.desvioPadrao, 4),
          },
          {
            key: '4',
            label: 'Coef. de Variação',
            children: (
              <CoeficienteVariacaoDisplay
                coeficienteVariacao={estatisticas.coeficienteVariacao}
              />
            ),
          },
          {
            key: '5',
            label: 'T de Student',
            children: formatarNumero(estatisticas.tStudent, 2),
          },
          {
            key: '6',
            label: 'Limite Superior (IC 80%)',
            children: (
              <LimiteDisplay
                valor={estatisticas.limiteSuperior}
                base={estatisticas.unitarioHomog}
                tipo="superior"
              />
            ),
          },
          {
            key: '7',
            label: 'Limite Inferior (IC 80%)',
            children: (
              <LimiteDisplay
                valor={estatisticas.limiteInferior}
                base={estatisticas.unitarioHomog}
                tipo="inferior"
              />
            ),
          },
          {
            key: '8',
            label: 'Intervalo de Confiabilidade',
            children: formatarNumero(estatisticas.intervaloConfiabilidade, 4),
          },
        ]}
      />
    </Space>
  );
}
